const t = '3.15.5';
const u = new Proxy(
  {},
  {
    get(e, i) {
      if (typeof i == 'string' && i.startsWith('iui-'))
        return i.replace('iui-', `_iui${t.replace(/\./g, '')}-`);
    },
    has(e, i) {
      return typeof i == 'string' && i.startsWith('iui-');
    },
  },
);
export { u as styles, t as version };
